import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { Text } from "@components/atoms/Text";

interface AccordionItemProps {
  question: string;
  answer: string;
}

/**
 * Accordion item atom.
 * Collapsible question/answer with chevron toggle.
 */
export function AccordionItem({ question, answer }: AccordionItemProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="w-full max-w-[645px] border-b border-neutral-90">
      <button
        className="flex w-full cursor-pointer items-center justify-between border-none bg-transparent py-4"
        onClick={() => setIsOpen(!isOpen)}
      >
        <Text
          variant="h5"
          as="span"
          className="text-left font-semibold text-black"
        >
          {question}
        </Text>
        {isOpen ? (
          <ChevronUp size={24} className="flex-shrink-0 text-black" />
        ) : (
          <ChevronDown size={24} className="flex-shrink-0 text-black" />
        )}
      </button>
      {isOpen && (
        <div className="pb-4">
          <Text variant="body" as="p" className="text-black leading-relaxed">
            {answer}
          </Text>
        </div>
      )}
    </div>
  );
}
